var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-main__warp monitor-page"},[_c('div',{staticClass:"left-content"},[_c('video-tree')],1),_c('div',{staticClass:"right-content"},[_c('video-player')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }